import type { MailboxInfo } from 'owa-client-types';
import { isSupportedAppServiceEnvironment } from '../utils/isSupportedAppServiceEnvironment';
import { isMOS3AppServiceAppsInMailAvailable } from './isMOS3AppServiceAppsInMailAvailable';
import { getApplicationSettings } from 'owa-application-settings';

export function isUnifiedAppStoreEnabled(mailboxInfo?: MailboxInfo): boolean {
    return (
        isSupportedAppServiceEnvironment(mailboxInfo) &&
        isMOS3AppServiceAppsInMailAvailable(mailboxInfo) &&
        getApplicationSettings('Mos3Urls', mailboxInfo).UnifiedStoreUrl !== ''
    );
}
